import { render, staticRenderFns } from "./FacilityView.vue?vue&type=template&id=6383475e&scoped=true&"
import script from "./FacilityView.vue?vue&type=script&lang=js&"
export * from "./FacilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6383475e",
  null
  
)

export default component.exports